var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-index load"},[_c('div',{staticClass:"loading animated fadeIn mx-auto"},[_c('div',{staticClass:"bg"})])])
}]

export { render, staticRenderFns }